<template>
  <div class="page-bg">
    <div class="page-main">
      <!-- 顶栏：返回按钮 + 标题 -->
      <PageHeader title="处方笺" @back="goBack" />

      <!-- 处方卡片列表 -->
      <div
        class="card"
        v-for="(item, index) in prescriptions"
        :key="index"
      >
        <h2 class="pres-name">名称：{{ item.name }}</h2>

        <div class="img-wrapper">
          <div :class="['print-div', 'img-print' + index]">
            <img :src="item.imageUrl" />
          </div>
        </div>

        <!-- <div class="page-num">{{ index + 1 }}/{{ prescriptions.length }}</div> -->

        <div class="btn-container">
          <button class="btn-action btn-print" @click="print(index)">打印处方</button>
          <button
            class="btn-action btn-ship"
            @click="fulfillment(index, item.name)"
            v-if="item.status == '0' || item.status == '1'"
          >{{ item.status == "0" ? item.name + "配送" : "配送详情" }}</button>
          <button class="btn-action btn-close" @click="close">关闭窗口</button>
        </div>

        <div class="divider"></div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/widgets/PageHeader.vue";

export default {
  components: { PageHeader },
  data() {
    return {
      prescriptions: [],
    };
  },
  created() {
    var visitRecordId = this.$route.query.visitRecordId;
    var params = { visitRecordId: visitRecordId };
    // 读取 URL 中的可选筛选参数
    var recordType = this.$route.query.recordType;
    var prescriptionTypeLabel = this.$route.query.prescriptionType;
    if (recordType) params.recordType = recordType;
    if (prescriptionTypeLabel) params.prescriptionType = prescriptionTypeLabel;
    this.wjtHttp.post(
      this,
      "/api/health/v2/prescription/image/filter",
      params,
      false,
      (res) => {
        var data = res.data;
        if (data.code == 200) {
          this.prescriptions = data.data;
        } else {
          this.$message({
            message:
              data.msg && data.msg.length > 0
                ? data.msg
                : "出方异常，请联系管理员",
            type: "error",
          });
        }
      },
      (err) => {
        console.log(err);
      }
    );
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    close() {
      this.$router.replace("/");
    },
    print(index) {
      var newstr = document.getElementsByClassName("img-print" + index)[0]
        .innerHTML;
      console.log(newstr);
      document.body.innerHTML = newstr;
      var oldstr = document.body.innerHTML;
      window.print();
      document.body.innerHTML = oldstr;
      window.location.reload();
    },
    fulfillment(index, name) {
      console.log(index, name);
      var prescription = this.prescriptions[index];
      if (prescription.status == 0) {
        var userInfo = this.$store.getters.getUserInfo;
        var roles = userInfo && userInfo.roles ? userInfo.roles : [];
        var isAgentDemo = false;
        for (var i = 0; i < roles.length; i++) {
          if (roles[i] == "level1" || roles[i] == "level2") {
            isAgentDemo = true;
            break;
          }
        }
        if (isAgentDemo) {
          this.$message.warning("当前为演示账号，配送下单功能暂未开放");
          return;
        }
        this.$confirm(
          `此患者共${this.prescriptions.length}有个处方，您正在确认配送${name}`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
        )
          .then(() => {
            sessionStorage.setItem(
              "prescription",
              JSON.stringify(prescription)
            );
            this.$store.commit("updateFulfillmentConfirmData", {});
            this.$router.push({
              path: "/fulfillmentConfirm",
              query: {
                index: index,
              },
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消配送",
            });
          });
      } else {
        this.$router.push({
          path: "/fulfillmentOrder",
          query: {
            orderId: prescription.deliveryOrderId,
          },
        });
      }
    },
  },
};
</script>

<style scoped>
/* ===== 页面背景 ===== */
.page-bg {
  min-height: 100vh;
  background: radial-gradient(circle at 78% 18%, rgba(235, 220, 173, 0.28), transparent 28%),
    linear-gradient(120deg, #eef8f2 0%, #f7fbf8 48%, #eef7f1 100%);
  font-family: 'Noto Sans SC', system-ui, sans-serif;
  color: #082b1c;
}

.page-main {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 24px;
}



/* ===== 卡片 ===== */
.card {
  background: #fff;
  border: 1px solid rgba(0, 70, 43, 0.1);
  border-radius: 30px;
  padding: 32px 40px;
  box-shadow: 0 14px 35px rgba(25, 70, 43, 0.08);
  margin-bottom: 28px;
}

/* ===== 处方名称 ===== */
.pres-name {
  font-size: 22px;
  font-weight: 700;
  color: #18334b;
  margin: 0 0 20px 0;
  text-align: center;
}

/* ===== 图片区 ===== */
.img-wrapper {
  width: 100%;
  max-width: 984px;
  margin: 0 auto;
  overflow: hidden;
}

.print-div {
  width: 100%;
}
.print-div img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== 页码 ===== */
.page-num {
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  margin-top: 20px;
}

/* ===== 按钮行 ===== */
.btn-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 36px;
  margin-top: 32px;
}

.btn-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 150px;
  height: 44px;
  padding: 0 28px;
  border: none;
  border-radius: 9999px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
}

/* 打印处方 */
.btn-print {
  background: #20863F;
  color: #fff;
  box-shadow: 0 10px 22px rgba(44, 132, 82, 0.22);
}
.btn-print:hover {
  background: #257648;
  transform: translateY(-1px);
}

/* 配送 */
.btn-ship {
  background: #f59a32;
  color: #fff;
  box-shadow: 0 10px 22px rgba(245, 154, 50, 0.22);
}
.btn-ship:hover {
  background: #ee8b1e;
  transform: translateY(-1px);
}

/* 关闭窗口 */
.btn-close {
  background: #fff;
  color: #617168;
  border: 1px solid #d6e5dc;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.btn-close:hover {
  border-color: #bbdac8;
  background: #f3fbf6;
  color: #1c7447;
}

/* ===== 分割线 ===== */
.divider {
  height: 1px;
  width: 100%;
  background-color: #e2e8f0;
  margin-top: 32px;
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .page-main {
    padding: 24px 16px;
  }
  .card {
    padding: 20px 16px;
    border-radius: 20px;
  }
  .page-title {
    font-size: 20px;
  }
  .pres-name {
    font-size: 18px;
  }
  .btn-container {
    gap: 16px;
  }
  .btn-action {
    min-width: 120px;
    height: 40px;
    font-size: 14px;
    padding: 0 20px;
  }
}
</style>
